import React from 'react';
import { Box, Grid, Input, Slider } from '@mui/material';
import styles from './Slider.module.scss';
import { GlobalVariables } from '../../../../../pdf/GlobalVariables';
import { ApryseSDK } from '../../../../../pdf/ApryseSDK';

interface ISliderPropertyProps {
    icon: JSX.Element;
    title: string;
    isEditMode: boolean;
    initialValue: number;
    minValue: number;
    maxValue: number;
    scrollSteps: number;
    updateValueFn: (newValue: number) => void;
    formatValueFn: (currentValue: number) => string;
}

/**
 * @param scrollSteps Steps for mousewheel usage
 */
export default (props: ISliderPropertyProps) => {
    const getSnap = (current: number, step: number, isForward: boolean) => {
        let snap = 1;
        const calc = () => (isForward ? current + snap : current - snap);
        while (calc() % step != 0) {
            snap += 1;
        }
        return snap;
    };

    const handleMouseWheel = (mouseWheelEvent: React.WheelEvent) => {
        if (mouseWheelEvent) {
            // Determine up or down
            const isUp = mouseWheelEvent.deltaY > 0 ? false : true;

            // Determine steps to snap
            const stepsToSnap = getSnap(props.initialValue, props.scrollSteps, isUp);

            const newValue = Math.min(
                Math.max(
                    0,
                    isUp ? props.initialValue + stepsToSnap : props.initialValue - stepsToSnap,
                ),
                100,
            );
            props.updateValueFn(newValue);
        }
    };

    const getTimeStamp = () => new Date().getTime();
    let timestamp = getTimeStamp();

    const handleSlider = (newValue: number | number[]) => {
        const ts = getTimeStamp();
        if (ts - timestamp < 50) {
            return;
        }
        props.updateValueFn(newValue as number);
        timestamp = ts;
    };

    // const handleBlur = () => {
    //   if (currentValue < 0) {
    //     setCurrentValue(0);
    //   } else if (currentValue > 100) {
    //     setCurrentValue(100);
    //   }
    // };

    return (
        <Box sx={{ width: '100%', position: 'relative' }}>
            <label className={styles.label}>{props.title}</label>
            <Grid container spacing={0} alignItems="center" m={0} className={styles.grid}>
                <Grid item pl={1.5} pr={0.5}>
                    {props.icon}
                </Grid>
                <Grid item xs px={1}>
                    <Slider
                        value={props.initialValue}
                        min={props.minValue}
                        max={props.maxValue}
                        valueLabelFormat={props.formatValueFn}
                        onChange={(_event, newValue) => handleSlider(newValue)}
                        onChangeCommitted={() => {
                            GlobalVariables.rotationAngles = {};
                            ApryseSDK.selectedAnnotations.forEach(annot =>
                                annot.enableRotationControl(),
                            );
                        }}
                        onWheel={handleMouseWheel}
                        disabled={!props.isEditMode}
                    />
                </Grid>
                <Grid item px={1}>
                    <Input
                        value={props.initialValue}
                        size="small"
                        onChange={event => handleSlider(parseFloat(event.target.value))}
                        // onBlur={handleBlur}
                        inputProps={{
                            step: 10,
                            min: 0,
                            max: 100,
                            type: 'number',
                            'aria-labelledby': 'input-slider',
                            className: styles.inputProps,
                        }}
                        className={styles.input}
                        disabled={!props.isEditMode}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};
